module.exports = __webpack_public_path__ + "img/img-google-download.16f905db.jpg";